import { Link } from 'solito/link'

import ArrowRightIcon from 'app/assets/icons/arrow-right.svg'
import IconButton from 'app/components/base/IconButton'
import Skeleton from 'app/components/base/Skeleton'
import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'
import { IS_NATIVE_APP } from 'app/utils/constants/env.constants'

interface HelpCenterLinkCardProps {
  categorySlug: string
  categoryName: string
  isActiveCategory: boolean
  hideBorderBottom?: boolean
  isLoading?: boolean
}

const HelpCenterLinkCard = ({
  categorySlug,
  categoryName,
  isActiveCategory,
  hideBorderBottom,
  isLoading
}: HelpCenterLinkCardProps) => {
  const link = `/help-centre/${categorySlug}`

  return (
    <Link href={link}>
      <Stack
        direction="row"
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
          cursor: 'pointer',
          py: 2,
          borderBottomWidth: { xs: hideBorderBottom ? 0 : 1, md: 1 },
          borderBottomStyle: 'solid',
          borderColor: 'stroke.main',
          ...(!IS_NATIVE_APP && {
            '&:hover > h5': {
              color: 'secondary.dark'
            }
          })
        }}
      >
        <Skeleton loading={isLoading} sx={{ width: '100%', height: 33 }}>
          <Text
            variant="h5"
            lineClamp={1}
            sx={{
              fontWeight: 500,
              ...(!isActiveCategory && {
                color: 'text.third'
              })
            }}
          >
            {categoryName}
          </Text>

          <IconButton size="small" disableRipple>
            <ArrowRightIcon />
          </IconButton>
        </Skeleton>
      </Stack>
    </Link>
  )
}

export default HelpCenterLinkCard
